import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/**
 * Format date as relative time (e.g., "2 years ago")
 * Returns "Unknown date" for invalid dates (Bug #3 fix)
 */
export function formatRelativeDate(dateString) {
  if (!dateString) return 'Unknown date';

  // Parse date with format: "DD MMM YYYY HH:mm:ss ZZ"
  const parsed = dayjs(dateString, 'DD MMM YYYY HH:mm:ss ZZ');

  // Validate parsed date (Bug #3 fix)
  if (!parsed.isValid()) {
    console.warn('Invalid date string:', dateString);
    return 'Unknown date';
  }

  return parsed.fromNow();
}

/**
 * Format date as full string
 */
export function formatFullDate(dateString) {
  if (!dateString) return 'Unknown date';

  const parsed = dayjs(dateString, 'DD MMM YYYY HH:mm:ss ZZ');

  if (!parsed.isValid()) {
    return 'Unknown date';
  }

  return parsed.format('MMMM D, YYYY');
}
